/**
 * AMC (Acclaim Motion Capture) Parser
 *
 * Parses CMU Motion Capture Lab AMC files into frame-by-frame joint angle data.
 * Format: frame number line followed by joint lines (name + angle values).
 */

export type Frame = Map<string, number[]>;

export interface MotionClip {
  frames: Frame[];
  frameCount: number;
}

export function parseAMC(text: string): MotionClip {
  const lines = text.split('\n');
  const frames: Frame[] = [];
  let currentFrame: Frame | null = null;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();
    if (!line || line.startsWith('#') || line.startsWith(':') || line === ':FULLY-SPECIFIED' || line === ':DEGREES') continue;

    const parts = line.split(/\s+/);

    // Frame number line: a single integer
    if (parts.length === 1 && /^\d+$/.test(parts[0])) {
      if (currentFrame) frames.push(currentFrame);
      currentFrame = new Map();
      continue;
    }

    // Joint data line: name followed by float values
    if (currentFrame && parts.length >= 2) {
      const name = parts[0];
      const values = parts.slice(1).map(Number);
      currentFrame.set(name, values);
    }
  }

  if (currentFrame) frames.push(currentFrame);

  return { frames, frameCount: frames.length };
}
